<template>
<!--  设备巡检计划审批-->
<div style="width: 100%;padding-top: 60px">
  <div style="position: fixed;top: 0;z-index: 999;width: 100%;">
    <div style="text-align:center">
      <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
        办理
      </van-button>
      <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
    </div>

    <div class="doTask" v-if="isshow">
      <div>
        <van-field name="radio" label="审批意见">
          <template #input>
            <van-radio-group v-model="auditForm.status" direction="horizontal">
              <van-radio name="同意">同意</van-radio>
              <van-radio name="不同意">不同意</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </div>
      <div>
        <van-cell-group>
          <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                     placeholder="请输入审批说明"/>
        </van-cell-group>
      </div>
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
      </div>
    </div>
  </div>
  <van-collapse v-model="activeNames">
    <van-collapse-item title="设备巡检计划" name="1" v-if="inputForm.planType === '11'">
      <van-field label="物业项目名称" v-model="inputForm.projectName" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      <van-field label="计划名称" v-model="inputForm.planName" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      <van-field label="巡检周期" v-model="inputForm.planFrequency" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      <van-field v-if="inputForm.planPeriod == 1" label="巡检开始时间" v-model="inputForm.inspectionStartDate" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      <van-field v-if="inputForm.planPeriod != 1" label="巡检开始日期" v-model="inputForm.inspectionStartDate" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      <van-field v-if="inputForm.inspectionDays" label="巡检工期" v-model="inputForm.inspectionDays" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      <van-field label="责任人" v-model="inputForm.principalName" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      <van-field label="责任部门" v-model="inputForm.principalDeptName" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      <van-field label="计划有效期（起）" v-model="inputForm.planStartDate" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      <van-field label="计划有效期（止）" v-model="inputForm.planEndDate" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      <van-field label="巡检要求" v-model="inputForm.planRequirement" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
    </van-collapse-item>
    <van-collapse-item title="设备维保计划" name="1" v-if="inputForm.planType === '12'">
      <van-field label="物业项目名称" v-model="inputForm.projectName" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      <van-field label="计划名称" v-model="inputForm.planName" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      <van-field label="维保类型" v-model="inputForm.maintenanceModeLabel" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      <van-field label="维保周期" v-model="inputForm.planFrequency" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      <van-field v-if="inputForm.planPeriod == 1" label="维保开始时间" v-model="inputForm.inspectionStartDate" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      <van-field v-if="inputForm.planPeriod != 1" label="维保开始日期" v-model="inputForm.inspectionStartDate" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      <van-field v-if="inputForm.inspectionDays" label="维保工期" v-model="inputForm.inspectionDays" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      <van-field label="责任人" v-model="inputForm.principalName" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      <van-field label="责任部门" v-model="inputForm.principalDeptName" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      <van-field label="计划有效期（起）" v-model="inputForm.planStartDate" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      <van-field label="计划有效期（止）" v-model="inputForm.planEndDate" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      <van-field label="维保要求" v-model="inputForm.planRequirement" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
    </van-collapse-item>
    <van-collapse-item name="2" title="关联设备">
      <b-table class="bgc-dark" small head-variant="dark" responsive bordered
               :items="items" :fields="fields">
        <template v-slot:head()="scope">
          <div class="text-nowrap" :style="{textAlign:'center'}">
            {{ scope.label }}
          </div>
        </template>

        <template v-slot:table-colgroup="scope">
          <col
              v-for="field in scope.fields"
              :key="field.key"
              :style="{ width: '100px' }"
          >
        </template>
      </b-table>
<!--      <table>-->
<!--        <thead>-->
<!--        <tr>-->
<!--          <td style="width: 120px;">物业项目名称</td>-->
<!--          <td style="width: 120px;">管理编码</td>-->
<!--&lt;!&ndash;          <td style="width: 20%;">设备编码</td>&ndash;&gt;-->
<!--          <td style="width: 120px;">设备名称</td>-->
<!--          <td style="width: 120px;">设备类型</td>-->
<!--          <td style="width: 120px;">设备等级</td>-->
<!--          <td style="width: 120px;">启用状态</td>-->
<!--          <td style="width: 120px;">运行状态</td>-->
<!--        </tr>-->
<!--        </thead>-->
<!--        <tbody>-->
<!--        <tr v-for="data in inputForm.equipmentList" :key="data.projectId">-->
<!--          <td>{{data.projectName}}</td>-->
<!--          <td>{{data.managementCode}}</td>-->
<!--&lt;!&ndash;          <td>{{data.equipmentCode}}</td>&ndash;&gt;-->
<!--          <td>{{data.name}}</td>-->
<!--          <td>{{data.equipmentTypeIdName}}</td>-->
<!--          <td>{{data.equipmentLevelIdName}}</td>-->
<!--          <td>{{data.enabledStatusName}}</td>-->
<!--          <td>{{data.runningStatusName}}</td>-->
<!--        </tr>-->
<!--        </tbody>-->
<!--      </table>-->
<!--      <van-field label="物业项目名称"></van-field>-->
<!--      <van-field label="管理编码"></van-field>-->
<!--      <van-field label="设备编码"></van-field>-->
<!--      <van-field label="设备名称"></van-field>-->
<!--      <van-field label="设备类型"></van-field>-->
<!--      <van-field label="设备等级"></van-field>-->
<!--      <van-field label="启用状态"></van-field>-->
<!--      <van-field label="运行状态"></van-field>-->
    </van-collapse-item>
  </van-collapse>

  <process-record :procInsId="procInsId"></process-record>
</div>
</template>

<script>
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import {queryById, startFlow} from '../../api/equipment/EquipmentInspectionPlan'
import processRecord from "../../components/processRecord/processRecord";
export default {
  name: "EquipmentInspectionPlan",
  data(){
    return {
      isshow: false,
      activeNames: ['1', '2'],
      inputForm: {
        id: '',
        projectId: '',
        projectName: '',
        planName: '',
        planType: '11', // wuye_plan_type计划类型[11设备巡检;12设备维保;20巡逻计划]
        planPeriod: '', // 巡检周期-每天
        planFrequency: '',
        planRequirement: '',
        principalId: '',
        principalName: '',
        principalDeptId: '',
        principalDeptName: '',
        inspectionDateDay: '1',  // 非空校验只是有值，无具体含义
        inspectionDateWeek: '',
        inspectionDateWeekArr: [], // 新增DTO字段
        inspectionDateMonth: '',
        inspectionDateMonthArr: [], // 新增DTO字段
        inspectionDate: '', // 巡检指定日期
        inspectionDays: '',
        planStartDate: '',
        planEndDate: '',
        equipmentMode: '',
        equipmentGroupId: '',
        publishStatus: '',
        auditStatus: '',
        equipmentList: [], // 设备列表
        remarks: '',
        isDoTask: false,
        isLastTask: false,
      },
      fields: [
        {key: 'projectName', label: '物业项目名称'},
        {key: 'managementCode', label: '管理编码'},
        {key: 'name', label: '设备名称'},
        {key: 'equipmentTypeIdName', label: '设备类型'},
        {key: 'equipmentLevelIdName', label: '设备等级'},
        {key: 'enabledStatusName', label: '启用状态'},
        {key: 'runningStatusName', label: '运行状态'},
      ],
      items: [],
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type: ''
    }
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
  },
  components: {
    processRecord
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },

    init(id) {
      queryById(id).then(({data}) => {
        this.inputForm = data
        this.items = data.equipmentList
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    timestampToTime(timestamp) {
      let date = new Date(timestamp);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d;// + " " + h + ":" + m + ":" + s;
    },
    submitTask() {
      if (this.auditForm.status === '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = {...vars, ..._this.inputForm}
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = _this.inputForm.isLastTask ? 4 : 2;
          startFlow(_this.inputForm);

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = 3;
          startFlow(_this.inputForm);

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style>
.bgc-dark th {
  background-color: gainsboro !important;
  /*color: #FFFFFF!important;*/
  font-weight: bold;
}
</style>
